import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const ListDate = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="16"
      rx="2"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path d="M3 9H21" stroke="currentColor" strokeLinecap="round" />
    <path d="M7 2V5" stroke="currentColor" strokeLinecap="round" />
    <path d="M17 2V5" stroke="currentColor" strokeLinecap="round" />
  </svg>
);

export default ListDate;
